import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative border-t border-white/10 py-16 bg-slate-900/50 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="mb-6">
              <Logo width="w-12" height="h-12" textSize="text-2xl" linkTo="/" />
            </div>
            <p className="text-white/60 text-sm mb-6 max-w-md">
              {t('footer.companyDescription')}
            </p>
            <div className="flex items-center gap-4">
              {[
                { href: 'https://www.linkedin.com/company/inscius', img: '/sm/in.png', alt: t('footer.linkedinAlt') },
                { href: 'https://www.instagram.com/in_scius/', img: '/sm/ig.png', alt: t('footer.instagramAlt') },
                { href: 'https://www.facebook.com/profile.php?id=61574231191513', img: '/sm/fb.png', alt: t('footer.facebookAlt') },
                { href: 'https://x.com/in_scius_sl', img: '/sm/x.png', alt: t('footer.xAlt') }
              ].map((social, idx) => (
                <a key={idx} href={social.href} target="_blank" rel="noreferrer" className="w-10 h-10 bg-white/5 hover:bg-brand-secondary/20 border border-white/10 hover:border-brand-secondary/50 rounded-lg flex items-center justify-center transition-all duration-300 group">
                  <img src={social.img} alt={social.alt} className="h-5 w-5 opacity-60 group-hover:opacity-100 transition-opacity"/>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-lg">{t('footer.footerProduct')}</h3>
            <ul className="space-y-3">
                <li>
                <Link to="/demo" className="text-white/60 hover:text-brand-secondary text-sm transition-colors">
                  {t('footer.navDemo')}
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-white/60 hover:text-brand-secondary text-sm transition-colors">
                  {t('footer.navHowItWorks')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-white/60 hover:text-brand-secondary text-sm transition-colors">
                  {t('footer.navSolutions')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-lg">{t('footer.footerLegal')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://inscius.es/en/about-us" target="_blank" rel="noreferrer" className="text-white/60 hover:text-brand-secondary text-sm transition-colors">
                  {t('footer.footerAbout')}
                </a>
              </li>
              <li>
                <Link to="/privacy" className="text-white/60 hover:text-brand-secondary text-sm transition-colors">
                  {t('footer.footerPrivacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-white/60 hover:text-brand-secondary text-sm transition-colors">
                  {t('footer.footerTerms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <a href="https://inscius.ai" target="_blank" rel="noreferrer" className="text-white/40 hover:text-brand-secondary text-sm transition-colors">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
